module.exports = __webpack_public_path__ + "static/media/weather_app.d9c20c7e.png";